import classNames from 'classnames/bind';
import React, { Suspense } from 'react';

import { ChevronUp } from '../../assets/icons/Icons';
import Styles from './Table.module.scss';

const cx = classNames.bind(Styles);
const TableDownload = React.lazy(() => import('./TableDownload'));

type TableProps = {
  children: React.ReactNode & React.ReactNode[];
  fixHeader?: boolean;
  fixColumn?: boolean;
  sticky?: boolean;
  downloadButton?: boolean;
  className?: string;
  grid?: boolean;
  type?: 'primary' | 'secondary';
};

function Table({
  children,
  fixHeader,
  fixColumn,
  sticky,
  downloadButton,
  className,
  grid = true,
  type = 'primary',
}: TableProps) {
  const classList = cx(
    'table',
    `table-${type}`,
    { 'table--fix-header': fixHeader },
    { 'table--fix-column': fixColumn },
    { sticky: sticky },
    { grid: grid },
  );

  if (fixHeader || fixColumn) {
    return (
      <div className={`${cx('table-wrapper')} ${className}`} data-testid='table'>
        <table className={classList}>{children}</table>
      </div>
    );
  } else if (downloadButton) {
    return (
      <Suspense fallback={null}>
        <TableDownload>
          <table className={classList}>{children}</table>
        </TableDownload>
      </Suspense>
    );
  } else {
    return (
      <table className={`${classList} ${className || ''}`} data-testid='table'>
        {children}
      </table>
    );
  }
}

type TableSortableThProps = {
  children: React.ReactNode;
  showArrow?: boolean;
  isAscending?: boolean;
  onSort: (isAscending: boolean) => void;
  className?: string;
  selected?: boolean;
  [key: string]: any;
};

const TableSortableTh: React.FC<TableSortableThProps> = ({
  children,
  showArrow = true,
  isAscending,
  onSort,
  className,
  selected,
  ...otherProps
}) => {
  return (
    <th
      className={cx('table__sortable-th') + (className ? ' ' + className : '')}
      {...otherProps}
      onClick={() => {
        onSort(!isAscending);
      }}
      data-testid='sortable-th'>
      {children}
      {showArrow ? (
        <span className={cx('chevron', { 'chevron--down': !isAscending }, { 'chevron--selected': selected })}>
          {ChevronUp}
        </span>
      ) : null}
    </th>
  );
};

export { Table, TableSortableTh };
